var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"footer_old_index"},[_c('div',{staticStyle:{"margin-top":"10px"}},[_vm._v(" Copyright ©2012-2015 12/5000 Xiamen Zongheng Technology Co., Ltd All Rights Reserved ")]),_c('div',[_vm._v(" 厦门纵横科技有限公司 闽ICP备12345678号 ")])])])
}]

export { render, staticRenderFns }